import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import { Button, Tooltip } from 'flowbite-react';
import { HiPlus } from 'react-icons/hi';
import { Vendor } from '../../Models/Vendor';
import VendorListTable from './VendorListTable';
import VendorApi from '../../Api/VendorApi';
import VendorAddModal from './VendorAddModal';

export default function VendorList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [vendorListData, setVendorListData] = useState<Vendor[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddVendor, setShowAddVendor] = useState<boolean>(false);

  useEffect(() => {
    getVendors();
  }, [userModel]);

  const getVendors = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        return VendorApi.getVendorsList()
          .then((res) => {
            setVendorListData(res.data);

            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  };
  const handleAddVendorClick = () => {
    setShowAddVendor(true);
  };

  function deleteVendor(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    if (shouldRemove) {
      // EquipmentApi.deleteEquipment(id)
      //   .then((res) => {
      //     if (res.data.success) {
      //       toast.success(res.data.message);
      //       getEquipments();
      //     } else {
      //       toast.success('Error while deleting item');
      //     }
      //   })
      //   .catch((err) => {
      //     toast.error('Error: ' + err);
      //   });
    }
  }
  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Vendor List</div>
              </h1>
            </div>
            {checkAccess() && (
              <div className=''>
                <Tooltip content={`Add Vendor`}>
                  <Button onClick={handleAddVendorClick} className='buttonMain'>
                    <HiPlus size={20} />
                  </Button>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        <div className='w-full p-4 h-[calc(100vh-48px)] overflow-y-auto'>
          <div className='relative'>
            {isLoading && <Loader />}
            <VendorListTable data={vendorListData} />
          </div>
        </div>
      </div>
      <VendorAddModal
        show={showAddVendor}
        setShow={setShowAddVendor}
        getVendors={getVendors}
      />
    </>
  );
}
